/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   moveIn validator
 */

import type { MoveInDateInputProps } from '@zcode-ui/web-zumper-ui'
import { isBefore, isToday } from 'date-fns'
import * as Yup from 'yup'

const ERROR_PAST_DATE = 'Please choose a move-in date that is not in the past'
const ERROR_REQUIRED_DATE = 'Move-in date is required'

export const checkDateValidity = (
  date: Date | string | null | undefined
): date is Date | string => {
  if (date) {
    const today = new Date()
    const selectedDate = new Date(date)
    return !isBefore(selectedDate, today) || isToday(selectedDate)
  }
  return true
}

export const moveInRequiredValidator = Yup.date()
  .required(ERROR_REQUIRED_DATE)
  .test({
    message: ERROR_PAST_DATE,
    test: (date: Date | string | null | undefined) => {
      return checkDateValidity(date)
    },
  })

export const moveInOptionalValidator = Yup.date().test({
  message: ERROR_PAST_DATE,
  test: (date: Date | string | null | undefined) => {
    return checkDateValidity(date)
  },
})

export const moveInTextValidator = Yup.string().oneOf([
  'ASAP' as const,
  'In the next 30 days' as const,
  'Later this year' as const,
] satisfies Array<Parameters<MoveInDateInputProps['onSelectMoveInDate']>[1]>)
